/**
 * @file: orgMemberToProductAuthor.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 *
 * Map an OrgMember (picked from the staff list) into the ProductAuthorInfo
 * shape used by product-manifest attribution (referrer / adopter / closer).
 * The BE only accepts ServiceAgent / Technicians as closer types; anything
 * else falls back to Technicians here so the picker's pre-validation
 * matches what the server enforces.
 */

import { OrgUserRoleHelper } from '@euler/functions/OrgUserRoleHelper';
import { OrgMember } from '@euler/model/entity';
import { OrgUserRoleType, ProductAuthorType } from '@euler/model/enum';
import { ProductAuthorInfo } from '@euler/model/product';

export function orgMemberToProductAuthor(member: OrgMember): ProductAuthorInfo {
  const helper = new OrgUserRoleHelper(member.role);
  return {
    id: member.id,
    name: member.name,
    type: helper.hasRole(OrgUserRoleType.ServiceAgents)
      ? ProductAuthorType.ServiceAgent
      : ProductAuthorType.Technicians,
  };
}
